import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { OnClick, OnMouseDown } from "../dom-tools/EventListeners";
import { DOMOrientation } from "../dom/DOMOrientation";

export class SmartLinkOptions
{
  onSmartLink:( href:string )=>void;
  landscapeOnly?:boolean = false;  
}

export class SmartLink
{
  static pageHandlingAttribute = new ElementAttribute( "page-handling" );

  static create( a:HTMLAnchorElement, options:SmartLinkOptions )
  {
    OnMouseDown.add( 
      a, 
      ( e )=>
      {
        let hasRequest = e.button === 0;
        
        if ( options.landscapeOnly )
        {
          hasRequest = hasRequest && DOMOrientation.isLandscape;
        }

        SmartLink.pageHandlingAttribute.to( a, hasRequest + "" );
      }
    );

    OnClick.add(
      a,
      ( e )=>
      {
        let href = ElementAttribute.href.from( a );

        let hasRequest = SmartLink.pageHandlingAttribute.is( a, "true" ); 

        if ( hasRequest )
        {          
          ElementAttribute.href.removeFrom( a ); 
          a.removeAttribute( "href" );

          options.onSmartLink( href );
  
          e.preventDefault();
          e.stopImmediatePropagation();
          e.stopPropagation();

          setTimeout(
            ()=>
            {
              ElementAttribute.href.to( a, href );
            },
            200
          )
        }
      }
    )

  }
}